import SlotResponse from '@data/schedules/types/SlotResponse';
import { getDateFromApiDateTime } from '@calendar/utilities';
import { BlockReleaseState } from '@data/blockReleases/types/BlockReleaseState';

export const checkIsBlockReleased = (block: Omit<SlotResponse, 'owners'>): boolean =>
	// legacy release logic
	(
		!!block.releaseDate &&
		getDateFromApiDateTime(block.releaseDate) < new Date()
	) ||
	// new release logic
	(
		block.release?.state === BlockReleaseState.MANUAL_RELEASE ||
		block.release?.state === BlockReleaseState.AUTO_RELEASE ||
		block.release?.state === BlockReleaseState.SSM_RELEASE
	);
